// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3LRq_","label":"Labeled_label__2EI0f","divider":"Labeled_divider__1njIL"};